<script lang="ts">
  import Option from './partial/Option.svelte';
  import MonitorInput from './partial/MonitorInput.svelte';
  import MonitorTriggerType from '$provider/constants/MonitorTriggerType';
  import type { MonitorOption } from '$shared/components/types';

  interface Props {
    option: MonitorOption;
    disabled?: boolean;
    children?: import('svelte').Snippet;
    onchange?: (config: any) => void;
  }

  let { option = $bindable(), disabled = false, children, onchange }: Props = $props();

  let showMonitorOption = $derived(
    !disabled && !option?.hideTriggerOption && option?.config?.enableMonitoring
  );

  let optionElement: Option = $state();

  const dispatchConfig = () => {
    onchange?.(option?.config);
  };

  const setNextDateToComp = (): void => {
    optionElement?.setDate(option?.config?.parsedNextMonitoringDate);
  };

  const onCheckboxChange = (e: any) => {
    option?.config && (option.config.enableMonitoring = e.target.checked);
    // Set next monitoring date when monitor checkbox is checked
    if (option?.config?.enableMonitoring && !option?.config.nextMonitoringDate) {
      option.config.setNextMonitoringDate();
    }
    setNextDateToComp();
    dispatchConfig();
  };

  const onIntervalChange = (detail: any) => {
    option?.config && (option.config.monitoringInterval = detail.id);
    // Set next monitoring date when interval is change, to update it on UI
    option?.config?.setNextMonitoringDate();
    // Reset the already selected date when interval is changed.
    optionElement?.resetDate();
    setNextDateToComp();
    dispatchConfig();
  };

  const onOptionsChange = (detail: any): void => {
    const { monitoringDate, active: activeType } = detail;
    option?.config && (option.config.triggerType = activeType);

    // If monitoring date is empty, then setNextMonitoringDate is setted based interval frequency
    if (activeType === MonitorTriggerType.Later && monitoringDate) {
      const date = new Date(monitoringDate);
      option?.config?.setNextMonitoringDate(date);
    }
    setNextDateToComp();
    dispatchConfig();
  };
</script>

<div class="comp-monitor">
  {#if option?.config}
    <MonitorInput {option} {disabled} oncheck={onCheckboxChange} oninterval={onIntervalChange}>
      {@render children?.()}
    </MonitorInput>
  {/if}
  {#if option?.warnMessage}
    <div class="warn">{option.warnMessage}</div>
  {/if}
  {#if showMonitorOption}
    <div class="monitor-option">
      <Option
        name={option?.name}
        isNewVerification={option?.config?.isNewVerification}
        bind:this={optionElement}
        onchange={onOptionsChange}
      />
    </div>
  {/if}
</div>

<style>
  .warn {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-medium);
    font-style: italic;
    border: 1px solid var(--grey-xlight);
    height: 80px;
    padding: 16px;
    background-color: var(--grey-bg);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .monitor-option {
    margin-top: 20px;
  }
</style>
